export default [{
  path: '/knowledge',
  component: () => import('@/views/knowledge/main'),
  children: [{
    path: 'abstract',
    component: () => import('@/views/knowledge/abstract/list')
  }, {
    path: 'report',
    component: () => import('@/views/knowledge/report')
  }]
}]